import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateMaterial({ username, onClose, onMaterialID, getMaterial }) {
    const [loading, setLoading] = useState(false);
    const [MetalList, setMetalList] = useState([]);
    const [errors, setErrors] = useState({});
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");

    const [formData, setFormData] = useState({
        name: "",
        matt_id: "",
        purity: "",
        unit: "",
        price: "",
        reference: "",
        comment: "",
        user_transaction: username,
        color: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    useEffect(() => {
        const getMaterialByID = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/select?id=${onMaterialID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        id: onMaterialID,
                        est_id: data.est_ID,
                        matt_id: data.matt_ID,
                        purity: data.purity,
                        unit: data.unit,
                        price: data.price,
                        reference: data.reference,
                        color: data.color
                    });
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getMaterialByID();
    }, [onMaterialID, username]);

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMetalList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getMetal();
    }, []);

    const validateFields = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Required field. Cannot be empty.";
        if (!formData.matt_id) newErrors.matt_id = "Required field. Cannot be empty.";
        if (!formData.purity) newErrors.purity = "Required field. Cannot be empty.";
        if (!formData.unit) newErrors.unit = "Required field. Cannot be empty.";
        if (!formData.price) newErrors.price = "Required field. Cannot be empty.";
        if (!formData.reference) newErrors.reference = "Required field. Cannot be empty.";
        return newErrors;
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${server_backend}/materials/update`, formData, headers);
                    if (response.data.RES_CODE === "00") {
                        setLoading(true);
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        getMaterial();
                        onClose();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Material already exists, please try another name.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);
                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="card">
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12 text-end">
                            <Link className='btn btn-danger me-2' onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then((result) => {
                                    if (result.isConfirmed) onClose();
                                });
                            }}>
                                Discard Changes
                            </Link>
                            <button onClick={handleUpdate} className="btn btn-primary">
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </div>

                    <div className="card-header">
                        <center>
                            <h4>Update Material</h4>
                        </center>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleUpdate}>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">ID</label>
                                    <input type="text" className="form-control" value={onMaterialID} disabled />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                        placeholder="Enter material name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                </div>

                                <div className="col-6 mb-3">
                                    <label className="form-label">Material Type</label>
                                    <select
                                        className={`form-select ${errors.matt_id ? "is-invalid" : ""}`}
                                        name="matt_id"
                                        value={formData.matt_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select the type of metal</option>
                                        {MetalList.map((Metal_R) => (
                                            <option key={Metal_R.matt_ID} value={Metal_R.matt_ID}>
                                                {Metal_R.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.matt_id && <div className="invalid-feedback">{errors.matt_id}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Purity</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.purity ? "is-invalid" : ""}`}
                                        placeholder="Enter purity"
                                        name="purity"
                                        value={formData.purity}
                                        onChange={handleChange}
                                    />
                                    {errors.purity && <div className="invalid-feedback">{errors.purity}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Unit</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.unit ? "is-invalid" : ""}`}
                                        placeholder="Enter unit"
                                        name="unit"
                                        value={formData.unit}
                                        onChange={handleChange}
                                    />
                                    {errors.unit && <div className="invalid-feedback">{errors.unit}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Price</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.price ? "is-invalid" : ""}`}
                                        placeholder="Enter price"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                    />
                                    {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Reference</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.reference ? "is-invalid" : ""}`}
                                        placeholder="Enter reference"
                                        name="reference"
                                        value={formData.reference}
                                        onChange={handleChange}
                                    />
                                    {errors.reference && <div className="invalid-feedback">{errors.reference}</div>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Color</label>
                                    <input
                                        type="color"
                                        className="form-control form-control-color"
                                        name="color"
                                        value={formData.color}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        name="est_id"
                                        value={formData.est_id}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Activated</option>
                                        <option value="2">Disabled</option>
                                    </select>
                                </div>

                                <div className="col-md-12 mb-3">
                                    <label htmlFor="comment" className="form-label">Xero Item Code</label>
                                    <input
                                        type='text'
                                        className="form-control"
                                        placeholder="Enter the item ID as a Xero reference"
                                        name="comment"
                                        value={formData.comment}
                                        onChange={handleChange}
                                    ></input>
                                </div>

                                <h4 className='p-3'>Other Information</h4>

                                <div className="col-6 mb-3">
                                    <label className="form-label">Date Created</label>
                                    <input type="text" className="form-control" value={vAdminformat.FormatDate(dateCreated)} disabled />
                                </div>

                                <div className="col-6 mb-3">
                                    <label className="form-label">User Created</label>
                                    <input type="text" className="form-control" value={userCreated} disabled />
                                </div>

                                <div className="col-6 mb-3">
                                    <label className="form-label">Date Modified</label>
                                    <input type="text" className="form-control" value={dateModify && vAdminformat.FormatDate(dateModify)} disabled />
                                </div>

                                <div className="col-6 mb-3">
                                    <label className="form-label">User Modified</label>
                                    <input type="text" className="form-control" value={userModify} disabled />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="card-header align-items-center d-flex">
                        <div className="col-md-12">
                            <div className="text-end">
                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>
                                <button onClick={handleUpdate} className="btn btn-primary">
                                    {loading ? "Updating..." : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default UpdateMaterial;
